import {GET_MarksSaving,GET_AutoMarksSaving} from '../constants/ActionTypes'

const INIT_STATE = {
    Message: null,
    loading: false,
    AutoSave:null
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case GET_MarksSaving:
           // console.log(action, 'actionnnn');
            return {
                Message: action.body,
                loading :false
            }
            case GET_AutoMarksSaving:
                //console.log(action, 'actionnnn');
                return {
                    AutoSave: action.body,
                    loading :false
                }
        default:
            return state;
    }
}